import { getDatasetsUrl, getDdbConnectionsUrl, getRemoveConnection, getRemoveConnections, getSaveConnection, getTestConnection, getDatasetsForAllConnections } from "../../../constants/urls";
import { getRequest, postRequest } from "../../../middlewares/api/actions";
export const DDB_CONNECTION_GET_CONNECTIONS = 'DDB_CONNECTION_GET_CONNECTIONS';
export const DDB_CONNECTION_SHOW_CONNECTION_MODAL = 'DDB_CONNECTION_SHOW_CONNECTION_MODAL';
export const DDB_CONNECTION_HIDE_CONNECTION_MODAL = 'DDB_CONNECTION_HIDE_CONNECTION_MODAL';
export const DDB_CONNECTION_TAB_CONNECTION_PARAMETERS = 'DDB_CONNECTION_TAB_CONNECTION_PARAMETERS';
export const DDB_CONNECTION_REMOVE_CONNECTION = 'DDB_CONNECTION_REMOVE_CONNECTION';
export const DDB_CONNECTION_REMOVE_CONNECTIONS = 'DDB_CONNECTION_REMOVE_CONNECTIONS';
export const DDB_CONNECTION_SHOW_DETAIL = 'DDB_CONNECTION_SHOW_DETAIL';
export const DDB_CONNECTION_HIDE_DETAIL = 'DDB_CONNECTION_HIDE_DETAIL';
export const MDMDATABASE = 'MDM Database';
export const MSSQLSERVER = 'MS SQL Server';
export const ORACLE = 'Oracle';
export const MYSQL = 'MySQL/MariaDB';
export const DDB_CONNECTION_SAVE_CONNECTION = 'DDB_CONNECTION_SAVE_CONNECTION';
export const DDB_CONNECTION_GET_DATASET = 'DDB_CONNECTION_GET_DATASET'
export const DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS = 'DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS'
export const DDB_CONNECTION_GET_CONNECTION_DETAIL = 'DDB_CONNECTION_GET_CONNECTION_DETAIL';
export const DDB_CONNECTION_TEST_CONNECTION = 'DDB_CONNECTION_TEST_CONNECTION';
export const DDB_CONNECTION_IS_CONNECTION_STRING_REMOVED = 'DDB_CONNECTION_IS_CONNECTION_STRING_REMOVED';

export const getDdbConnections = ({
                                    username,
                                    permissions,
                                    token,
                                    email,
                                    metadataFlow,
                                    dataflow,
                                    isAuthenticated,
                                    dbbConnections
                                }) => postRequest(
    DDB_CONNECTION_GET_CONNECTIONS,
    getDdbConnectionsUrl(),
    {   
        username,
        permissions,
        token,
        email,
        metadataFlow,
        dataflow,
        isAuthenticated,
        dbbConnections
    }
)

export const getDatasets = (entityId,username) => getRequest(
    DDB_CONNECTION_GET_DATASET,
    getDatasetsUrl(entityId,username),
)

export const getDatasetsForMultipleConnections = (entityIdarray) => postRequest(
    DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS,
    getDatasetsForAllConnections(),
    entityIdarray
)

// Prende i dati della connessione
export const getConnectionDetail = (entityId) => ({
    type: DDB_CONNECTION_GET_CONNECTION_DETAIL,
    entityId
})

export const saveDdbConnection = (connection) => postRequest(
    DDB_CONNECTION_SAVE_CONNECTION,
    getSaveConnection(),
    connection,
    t => ({
        success: connection.entityId === '' ? t('scenes.mappingHandler.DDBConnection.messages.success.save') : t('scenes.mappingHandler.DDBConnection.messages.success.edit')
    }),
)

export const showConnectionModal = () => ({
    type: DDB_CONNECTION_SHOW_CONNECTION_MODAL
})

export const hideConnectionModal = () => ({
    type: DDB_CONNECTION_HIDE_CONNECTION_MODAL
})

export const removeDdbConnection = (connection) => ({...postRequest(
    DDB_CONNECTION_REMOVE_CONNECTION,
    getRemoveConnection(),
    connection,
    t => ({
        success: t('scenes.mappingHandler.DDBConnection.messages.success.delete')
    }),
), connectionDeleted: connection})

export const removeDbdConnections = (connectionArr) => ({...postRequest(
    DDB_CONNECTION_REMOVE_CONNECTIONS,
    getRemoveConnections(),
    connectionArr,
    t => ({
        success: t('scenes.mappingHandler.DDBConnection.messages.success.multipleDelete')
    }),
), connectionsDeleted: connectionArr})

// Mostra il modal di edit/create connection
export const showDetailDdbConnection = (data, creating) => ({
    type: DDB_CONNECTION_SHOW_DETAIL,
    data,
    creating
})

export const hideDetailDdbConnection = () => ({
    type: DDB_CONNECTION_HIDE_DETAIL
})

export const testDdbConnection = (connection) => postRequest(
    DDB_CONNECTION_TEST_CONNECTION,
    getTestConnection(),
    connection
)

/*Evento scatenato al click sul bottone di reset del selector 
* per la scelta di una connessione, quando il dbType è MDM 
*/
export const isConnectionStringRemoved = (isConnectionRemoved) => ({
    type: DDB_CONNECTION_IS_CONNECTION_STRING_REMOVED,
    isConnectionRemoved
})